import { extendTheme } from '@chakra-ui/react';

const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

const colors = {
  brand: {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#007bff', // Datarunk primary blue
    600: '#0056b3',
    700: '#003d82',
    800: '#002952',
    900: '#001529',
  },
  dark: {
    bg: '#0a0e1a', // Dark blue-black (Datarunk style)
    card: '#151b2e',
    text: '#e8eaf0',
    muted: '#8b95a8',
  }
};

const styles = {
  global: (props) => ({
    body: {
      bg: props.colorMode === 'dark' ? 'dark.bg' : 'gray.50',
      color: props.colorMode === 'dark' ? 'dark.text' : 'gray.800',
    },
  }),
};

const components = {
  Card: {
    baseStyle: (props) => ({
      container: {
        bg: props.colorMode === 'dark' ? 'dark.card' : 'white',
        borderColor: props.colorMode === 'dark' ? 'whiteAlpha.100' : 'gray.200',
        borderWidth: '1px',
        boxShadow: 'xl',
        borderRadius: 'xl',
      },
      header: {
        pb: 2,
      },
      body: {
        pt: 2,
      }
    }),
  },
  Heading: {
    baseStyle: {
      fontWeight: '700',
      letterSpacing: '-0.02em',
    },
  },
  Text: {
    baseStyle: (props) => ({
      color: props.colorMode === 'dark' ? 'dark.text' : 'gray.600',
    }),
  },
  Slider: {
    baseStyle: {
      thumb: {
        bg: 'brand.400',
      },
      filledTrack: {
        bg: 'brand.400',
      },
    },
  },
};

const theme = extendTheme({ config, colors, styles, components });

export default theme;